import { useState } from 'react'
import Popout from '../components/Popout'
import { sendBackgroundViaAppInvitation } from '../util/shareBackgroundViaAppInvitation'
import shareIcon from './share.png'

import './ShareButton.css'

const ShareButton = ({ image }) => {
  const [isHover, setIsHover] = useState(false)

  const onClick = () => {
    sendBackgroundViaAppInvitation(image)
  }

  const onMouseEnter = () => {
    setIsHover(true)
  }

  const onMouseLeave = () => {
    setIsHover(false)
  }

  return (
    <Popout content="Share" visible={isHover}>
      <button
        onClick={onClick}
        className="icon-button"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <img src={shareIcon} alt="share button" />
      </button>
    </Popout>
  )
}

export default ShareButton
